<div class="row">
  <div class="col-md-12 text-center">
    <label style="font-size: 96px; color: red">
      <span>
        <i class="pi pi-exclamation-circle" style="font-size: 6rem"></i>
      </span>
      No Permissions
      <span>
        <i class="pi pi-exclamation-circle" style="font-size: 6rem"></i>
      </span>
    </label>
    <h4>You do not have permissions to access anything in this application.</h4>
    <p></p>
    <h4>
      To obtain access to this application, please go to
      <a href="https://myaccess2.corteva.com" target="_blank" rel="noopener noreferrer">MyAccess</a> and request permissions.
    </h4>
    <p></p>
  </div>
</div>
